/* eslint-disable */
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AdminCard from "./Card/AdminCard";

const AdministrationBody = () => {
  // Configuration for administration cards with icons and categories
  const adminCardList = [
    {
      roles: ["SUPER_ADMIN"],
      cards: [
        {
          title: "Ecosystem",
          description: "Show all Ecosystems associated with the app",
          link: "/admin/administration/ecosystems",
          linkText: "Manage Ecosystems",
          icon: "hub",
          color: "primary",
        },
        {
          title: "App Users Role",
          description: "Show various roles of App Users",
          link: "/admin/administration/roles",
          linkText: "Manage Roles",
          icon: "group",
          color: "primary",
        },
        {
          title: "Action Logs",
          description: "Show various logs of this application",
          link: "/admin/administration/actionlogs",
          linkText: "View Action logs",
          icon: "history",
          color: "primary",
        },
      ],
    },
    {
      roles: ["SUPER_ADMIN"],
      cards: [
        {
          title: "Modules",
          description: "Show Ecosystem Modules",
          link: "/admin/administration/modules",
          linkText: "Manage Modules",
          icon: "extension",
          color: "primary",
        },
        {
          title: "Module Privileges By User Role",
          description: "Module privileges for to app user by roles",
          link: "/admin/administration/moduleroleprivilege",
          linkText: "Manage Module Privileges",
          icon: "security",
          color: "primary",
        },
        {
          title: "AI Prompt",
          description:
            "Manage AI Prompts, Models, Knowledge base and Chat Bots",
          link: "/admin/administration/gptprompt",
          linkText: "View AI prompts",
          icon: "psychology",
          color: "primary",
        },
      ],
    },
    {
      roles: ["ADMIN", "SUPER_ADMIN"],
      cards: [
        {
          title: "Module Roles",
          description: "Add roles in different modules for access rights",
          link: "/admin/administration/moduleroles",
          linkText: "Manage Module Roles",
          icon: "admin_panel_settings",
          color: "primary",
        },
        {
          title: "Categories",
          description: "Show all Categories added in this ecosystems",
          link: "/admin/administration/categories/list",
          linkText: "Manage Categories",
          icon: "category",
          color: "primary",
        },
        // {
        //   title: "Plans",
        //   description: "Plans for subscription in current Ecosystem",
        //   link: "/admin/administration/plans",
        //   linkText: "Manage Plans",
        //   icon: "payments",
        //   color: "primary",
        // },
      ],
    },
    {
      roles: ["ADMIN", "SUPER_ADMIN"],
      cards: [
        {
          title: "Tags",
          description: "Manage tags for all users",
          link: "/admin/administration/tags",
          linkText: "Manage Tags",
          icon: "local_offer",
          color: "primary",
        },
        {
          title: "Activity Process Template",
          description: "Manage kanban template for organize labels",
          link: "/admin/administration/activityprocess/list",
          linkText: "Manage Activity Process Template",
          icon: "view_kanban",
          color: "primary",
        },
        {
          title: "Mail Template",
          description: "Manage mail template for organize templates",
          link: "/admin/administration/mailtemplate/list",
          linkText: "Manage Mail Template",
          icon: "email",
          color: "primary",
        },
        {
          title: "Treatment Template",
          description: "Manage treatment template for organize templates",
          link: "/admin/administration/treatmentmanagement/templates",
          linkText: "Manage Treatment Template",
          icon: "email",
          color: "primary",
        },
      ],
    },
    {
      roles: ["ADMIN", "SUPER_ADMIN"],
      cards: [
        {
          title: "Clinic Type",
          description: "Manage clinic types for companies",
          link: "/admin/administration/companytype",
          linkText: "Manage Clinic Types",
          icon: "meeting_room",
          color: "primary",
        },
        {
          title: "Product Type",
          description: "Manage product types for products",
          link: "/admin/administration/producttype",
          linkText: "Manage Product Types",
          icon: "production_quantity_limits",
          color: "primary",
        },
        // {
        //   title: "Event Type",
        //   description: "Manage event types for events",
        //   link: "/admin/administration/eventtype",
        //   linkText: "Manage Event Types",
        //   icon: "event",
        //   color: "primary",
        // },
        {
          title: "Lab Test Templates",
          description: "Manage lab test templates",
          link: "/admin/administration/labtesttemplates",
          linkText: "Manage Lab Test Templates",
          icon: "science",
          color: "primary",
        },
      ],
    },
  ];

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const currentUserRole = userInfo.role ? userInfo.role.slug : "";

  // Check admin access
  if (!["ADMIN", "SUPER_ADMIN"].includes(currentUserRole)) {
    return <AccessDeniedView />;
  }

  // Render card groups with improved styling
  const renderCardGroups = () =>
    adminCardList.map((group, index) => {
      if (group.roles.includes(currentUserRole)) {
        return (
          <div key={`group-${index}`} className="mb-4">
            {/* Cards Grid */}
            <div className="row" style={{ gap: "1.5rem 0" }}>
              {group.cards.map((card, cardIndex) => (
                <AdminCard key={cardIndex} card={card} />
              ))}
            </div>
          </div>
        );
      }
      return null;
    });

  // Main content for admins
  return (
    <div id="content_wrapper">
      <section className="dashboard-wrapper pb-2">
        <div className="container-fluid px-lg-5 pt-4">
          {/* Page Header */}
          <div className="mb-4">
            <div className="bg-white rounded-15 shadow-md p-4">
              <div
                className="d-flex align-items-center"
                style={{ gap: "1rem" }}
              >
                <div
                  className="rounded-15 p-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                    backgroundColor: "var(--bs-primary)",
                  }}
                >
                  <span className="material-symbols-outlined text-white fs-lg">
                    settings
                  </span>
                </div>
                <div>
                  <h1 className="h2 fw-bold mb-1">Administration Panel</h1>
                  <p className="mb-0" style={{ color: "var(--bs-gray-500)" }}>
                    Manage your application settings and configurations
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Admin Cards */}
          {renderCardGroups()}
        </div>
      </section>
    </div>
  );
};

export default AdministrationBody;
